module.exports = __webpack_public_path__ + "img/avo.b953ad69.png";